export default __webpack_public_path__ + "static/media/check-icon.c8ee2317.svg";